// extracted by mini-css-extract-plugin
export default {"small-card":"SmallCard_small-card__DZyyR","text":"SmallCard_text__qu0hn","album":"SmallCard_album__6W474","play":"SmallCard_play__p9S2C"};